export const globalNavigationAndTopBannerQuery = `
query GlobalNavigationAndTopBannerByVariant($variantId: String!) {
  all_global_navigation_v2(where: { variation_id: $variantId }) {
    items {
      l1_navigation {
        featured
        department_navigationConnection {
          edges {
            node {
              ... on DepartmentNavigation {
                title
                l1_display_text
                l1_navigation_linkConnection {
                  edges {
                    node {
                      ... on Department {
                        title
                        url
                      }
                    }
                  }
                }
                l2_navigation {
                  l2_display_text
                  l2_navigation_linkConnection {
                    edges {
                      node {
                        ... on ProductListingPage {
                          url
                          heading
                        }
                        ... on Inspiration {
                          title
                          url
                        }
                        ... on Generalcontentpage {
                          title
                          url
                        }
                        ... on Department {
                          title
                          url
                        }
                        ... on About {
                          title
                          url
                        }
                      }
                    }
                  }
                  l3_navigation {
                    l3_display_text
                    l3_navigation_linkConnection {
                      edges {
                        node {
                          ... on About {
                            title
                            url
                          }
                          ... on Department {
                            title
                            url
                          }
                          ... on Generalcontentpage {
                            title
                            url
                          }
                          ... on Inspiration {
                            title
                            url
                          }
                          ... on ProductListingPage {
                            url
                            heading
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      top_banner_referenceConnection {
        edges {
          node {
            ... on TopBanner {
              title
              offer_message {
                background_color
                text_color
                offer_message_referenceConnection {
                  edges {
                    node {
                      ... on OfferMessage {
                        title
                        message
                        page_referenceConnection {
                          edges {
                            node {
                              ... on ProductListingPage {
                                url
                              }
                              ... on Department {
                                url
                              }
                              ... on CampaignTc {
                                url
                              }
                            }
                          }
                        }
                        modular_content {
                          ... on OfferMessageModularContentPromoCode {
                            __typename
                            promo_code {
                              promo_code
                            }
                          }
                          ... on OfferMessageModularContentCountdown {
                            __typename
                            countdown {
                              end_date
                              message_when_countdown_shows
                              threshold
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}`;
